import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDatabaseImport = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M11.614 9.073c4.172 0 7.554-1.364 7.554-3.047s-3.382-3.047-7.554-3.047S4.06 4.343 4.06 6.026s3.382 3.047 7.554 3.047Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.06 12v6.014s0 3.008 7.597 3.008M19.168 11.557V5.984"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.06 5.984V12s0 3.007 7.597 3.007M14.308 18.205l2.817 2.817 2.816-2.817M17.125 14.363v6.659"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgDatabaseImport);
export default ForwardRef;
